import _axios from '@/services/axios';
import { Component, Vue } from 'vue-property-decorator';
import WithRender from './balance.html';
import config from "@/settings/config.js";
import UserSignonChart from '@/components/UserSignonChart.vue';

@WithRender
@Component({
  components: {
    UserSignonChart
  }
})
export default class Balance extends Vue {

    zesa: string | void = "";
    airtime: string | void = "";
    sa: string | void = "";
    airtel: string | void = "";
    tnm: string | void = "";
    econet: string | void = "";


    async mounted() {
        this.fetchBalance("zw", "hot", (value) => this.airtime = value);
        this.fetchBalance("za", "free", (value) => this.sa = value);
        this.fetchBalance("mw", "airtel", (value) => this.airtel = value);
        this.fetchBalance("mw", "tnm", (value) => this.tnm = value);
        this.fetchBalance("zw", "usdeconet", (value) => this.econet = value);
        this.fetchBalance("zw", "esol", (value) => this.zesa = value);
    }

    async fetchBalance(isoCountry: string, provider: string, callback: (value: string | null) => void) {
        try {
            const result = await this.getBalance(isoCountry, provider);
            callback(result || null);
        } catch (err) {
            console.error(`Failed to fetch balance for ${provider} (${isoCountry}):`, err);
            callback(null);
        }
    }

    async getBalance(isoCountry: string, provider: string): Promise<string | void> {
        try {
            const result = await _axios.get(`${config.gateway}recharge-api/balance?isoCountry=${isoCountry}&provider=${provider}`);
            console.log(result);
            return result.data;
        } catch (err) {
            console.error(err);
        }
    }
}

